/***
 * Fast Search - Search Form Modal
 */

const { useState, useEffect, createRoot } = wp.element;

const searchProps = {
	careers: {
		suggestedSearchTerms: [
			{ term: "Open Positions", path: "/about-us/careers/open-positions/" },
			{ term: "Externship", path: "/about-us/careers/externship/" },
			{ term: "Career Profiles", path: "about-us/careers/profiles/" },
			{
				term: "Top Workplaces",
				path: "articles/7-reasons-why-equity-methods-is-a-top-place-to-work/",
			},
			{ term: "Campus Candidates", path: "about-us/careers/campus-candidates" },
			{ term: "Tangerine", path: "about-us/careers/em-tangerine" },
		],
		searchFormAction: "/about-us/careers/search",
	},
	all: {
		suggestedSearchTerms: [
			{ term: "Knowledge Center", path: "/resources/knowledge-center/" },
			{ term: "ASC 718 Reporting" },
			{ term: "Pay Equity Analysis" },
			{ term: "Relative TSR" },
			{ term: "Pay vs. Performance" },
			{ term: "Complex Financial Instruments" },
		],
		searchFormAction: "/search",
	},
};

import Modal from "react-modal";

import DOMReady from "./util/dom-ready";
import "./search-form-modal.scss";

const SearchFormModal = (props) => {
	const [open, setOpen] = useState(false);
	const [results, setResults] = useState([]);
	const [searchStr, setSearchStr] = useState("");

	const { data } = props;

	const { audience } = data;

	const { suggestedSearchTerms, searchFormAction } =
		searchProps[audience] || searchProps.all;

	const handleClose = () => setOpen(false);

	const handleOpen = (e) => {
		e.preventDefault();
		setOpen(true);
	};

	const handleSearch = (e) => setSearchStr(e.target.value);

	const searchWithAPI = (query, audience) => {
		const url = new URL(location);

		url.searchParams.set("search", query);
		url.searchParams.set("per_page", 2);
		url.searchParams.set("audience", audience);

		fetch(`/wp-json/wp/v2/search${url.search}`)
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				throw new Error("Network response was not ok.");
			})
			.then((data) => {
				setResults(data.slice(0, 5));
			})
			.catch((error) => console.error("Error:", error));
	};

	useEffect(() => {
		if (searchStr.length > 3) {
			searchWithAPI(searchStr, audience);
		}
	}, [searchStr]);

	Modal.setAppElement("#fast-search-form-modal-root");

	return (
		<>
			<a className="search-toggle" onClick={handleOpen}></a>

			<Modal
				isOpen={open}
				aria-labeledby="searchform"
				aria-describedby="searchform"
				className={`search-form-modal search-form-modal--${audience}`}
			>
				<div>
					<button
						onClick={handleClose}
						className="close-button material-symbols-outlined"
					>
						close
					</button>

					<h2 id="modal-modal-title"></h2>
					<div className="search-form-modal-content">
						<div class="logo">
							<a href="/" class="logo__link">
								<img
									class="logo__image"
									src="/wp-content/themes/equity-methods-v2/images/equity-methods-logo-white.svg"
									alt="Equity Methods Logo"
								/>
							</a>
						</div>

						<p id="modal-modal-description"></p>
						<form method="get" id="searchform" action={searchFormAction}>
							<input
								type="text"
								id="searchinput"
								className="st-default-search-input"
								name="search"
								placeholder="Search"
								onChange={handleSearch}
							/>
							<input hidden type="text" defaultValue="relevance" name="sort" />
							<button className="search-submit material-symbols-outlined">
								Search
							</button>
						</form>

						<div className="search-list">
							{searchStr.length > 0 && results && results.length > 0 ? (
								<div>
									<h3>Suggested Results</h3>
									<ul>
										{results.map((result, index) => (
											<li key={index}>
												<a href={result.url}>{result.title}</a>
											</li>
										))}
									</ul>
								</div>
							) : null}
						</div>
						<div className="suggested-search-terms">
							<h3>Popular Searches</h3>
							{suggestedSearchTerms && suggestedSearchTerms.length > 0 ? (
								<ul>
									{suggestedSearchTerms.map((term, index) => (
										<li key={index}>
											<a
												href={
													term.path
														? `${term.path}`
														: `/search?search=${term.term}`
												}
											>
												{term.term}
											</a>
										</li>
									))}
								</ul>
							) : null}
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};

DOMReady(() => {
	const root = document.getElementById("fast-search-form-modal-root");
	if (root) {
		createRoot(root).render(
			<SearchFormModal
				suggestedSearchTerms={searchProps.suggestedSearchTerms}
				data={root.dataset}
			/>
		);
	}
});
